
define('text!platform/features/notebook/res/templates/notifications.html',[],function () { return '<span class="status block">\n    <!-- DO NOT ADD SPACES BETWEEN THE SPANS - IT ADDS WHITE SPACE!! -->\n    <span class="status-indicator icon-bell"></span>\n    <span class="label">\n        Notifications\n    </span>\n    <span class="count"></span>\n</span>\n';});

